$(function () {
  initCustomBCSF();
});

/**
 * Functions to extend the BC search and filter app, without
 * modifying the source code too much.
 */
function initCustomBCSF() {
  let firstLoad = true;
  let firstLoadMarketing = true;
  let allCollectionProducts = [];

  var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1;

  function runMarketingTile(ajax=false) {
    let collectionHandle = $('.section-collection').attr('data-collection-handle');
    $('.bc-sf-filter-product-item').each(function() {
      let el = $(this);
      let handle = el.attr('data-handle');

      let targetObject = marketingMetafields[handle];

      if(typeof targetObject != "undefined") {
        el.addClass('marketingTile');
        $('.bc-sf-filter-product-item-label', el).hide();
        $('.bc-sf-filter-product-bottom', el).hide();
        $('.itemFlair', el).hide();
        $('button', el).hide();
        $('a', el).attr('href', targetObject.marketing_tile_link);
      }
    });
  }

  function runColorCountFix(ajax=false) {
    //localStorage.setItem("allCollectionProducts", '{}');
    let allProducts = JSON.parse(localStorage.getItem("allCollectionProducts"));
    let collectionHandle = $('.section-collection').attr('data-collection-handle');
    if( !isSafari && allProducts != null && Object.keys(allProducts).length > 0 ) {

      let timestampNow = Math.floor(Date.now() / 1000);
      let localStorageTimestamp = localStorage.getItem("allCollectionProductsTimestamp");
      if( (timestampNow - parseInt(localStorageTimestamp)) > 300 ) {
        if(typeof collectionHandle != "undefined") {
          getAllCollectionProducts(collectionHandle);
        }
        else {
          getAllCollectionProducts('sample-dresses');
          getAllCollectionProducts('junior-at-home-try-on');
          getAllCollectionProducts('maternity-at-home-try-on');
          getAllCollectionProducts('wedding-dresses-at-home-try-on');
        }
      }
      else {
        firstLoad = false;
        if(!ajax) {
          $(window).on('load', function() {
            fixColorsCount(allProducts);
          });
        }
        else {
          fixColorsCount(allProducts);
        }
      }
    }
    else {
      if(typeof collectionHandle != "undefined") {
        getAllCollectionProducts(collectionHandle);
      }
      else {
        getAllCollectionProducts('sample-dresses');
        getAllCollectionProducts('junior-at-home-try-on');
        getAllCollectionProducts('maternity-at-home-try-on');
        getAllCollectionProducts('wedding-dresses-at-home-try-on');
      }
    }
  }

  runColorCountFix();

  $(document).on('ajaxComplete',function(e){
    if(
      !firstLoad &&
      typeof e.currentTarget.URL != "undefined" &&
      e.currentTarget.URL.indexOf('/collections/') > -1 &&
      e.currentTarget.URL.indexOf('products.json') < 0
    ) {
      setTimeout(function(){
        runColorCountFix(true);
      },100)
    }

    if(
        firstLoadMarketing &&
        typeof e.currentTarget.URL != "undefined" &&
        e.currentTarget.URL.indexOf('/collections/') > -1 &&
        e.currentTarget.URL.indexOf('products.json') < 0
    ) {
      runMarketingTile(true);
    }

  });

  /**
   * Recursively build an array of all products
   * in the given collection and fix swatches after it's done.
   *
   * @param handle
   * @param page
   * @param overwrite
   */
  function getAllCollectionProducts(handle=null, page=1, overwrite=false) {
    if(!handle) return;
    $.ajax({
      url: "/collections/"+handle+"/products.json?limit=250&page="+page,
      dataType: "json",
      success: function (json) {

        if(typeof json == "undefined") return;

        allCollectionProducts = allCollectionProducts.concat(json.products);

        if(typeof json.products != "undefined" && json.products.length > 0) {
          getAllCollectionProducts(handle, page + 1);
        }
        else {
          fixColorsCount(allCollectionProducts, true, overwrite);
        }

      }
    });
  }

  function fixColorsCount(allProducts, map=false, overwrite=false) {
    setTimeout(function(){
      let objects = {};
      // Map array so it becomes an object with handles as keys
      if( map ) {
        objects = mapProductsForColorCount(allProducts, overwrite);
      }
      else {
        objects = allProducts;
      }

      if(
        !(objects && Object.keys(objects).length === 0 && objects.constructor === Object)
      ) {
        // Start fixing the products
        $('.bc-sf-filter-product-item').each(function() {
          let el = $(this);
          let handle = el.attr('data-handle');
          let soldOutBadge = el.find('.bc-sf-filter-label.soldout');
          let colorCount = el.find('.list-colors li:last-child p');

          let targetObject = objects[handle];

          if(typeof targetObject != "undefined" && targetObject.hasOwnProperty('colorsCount')) {
            let strEnd = targetObject.colorsCount > 1 ? 's' : '';

            colorCount.html(targetObject.colorsCount + ' Color' + strEnd);
            soldOutBadge.addClass('hidden');
          }
          else {
            soldOutBadge.removeClass('hidden');
          }
        });
      }

    },10);
  }

  /**
   * This function links child sample products to their parents,
   * counts the available variants and adds a "colorsCount" parameter to the parent.
   *
   * @param allProducts
   * @param overwrite
   * @returns {*|{}}
   */
  function mapProductsForColorCount(allProducts, overwrite=false) {
    let objects = {};
    let newObjects = [];

    // Shrink data size by only saving what we need
    allProducts.forEach(function(prod) {
      let variants = [];
      prod.variants.forEach(function(variant) {
        let dataVar = {
          id: variant.id,
          title: variant.title,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
          available: variant.available,
        };
        variants.push(dataVar);
      });

      let data = {
        id: prod.id,
        handle: prod.handle,
        variants: variants,
      };
      newObjects.push(data)
    })

    // Turn the array into an object and use the product handle as the key
    let mapped = (arr, key) => arr.reduce((a, b) => ({ ...a, [b[key]]: b }), {});
    objects = mapped(newObjects,'handle');

    // Link child products that have different handles than parents
    objects = parseMetafieldColorCount(objects);

    // Get sizes products inside the parent product object
    for (let handle in objects) {
      if(!objects.hasOwnProperty(handle)) continue;
      let obj = objects[handle];
      if( obj.handle.indexOf('-size-') > -1 ) {
        let parentHandle = obj.handle.split('-size-')[0];

        if(objects.hasOwnProperty(parentHandle)) {
          if( typeof objects[parentHandle].sizes == "undefined" ) objects[parentHandle].sizes = [];
          objects[parentHandle].sizes.push(obj);
          delete objects[obj.handle];
        }
      }
    }

    // Get the available colors count for products not in the metafield
    for (let handle in objects) {
      if(!objects.hasOwnProperty(handle)) continue;
      let obj = objects[handle];

      if(obj.hasOwnProperty('sizes')) {
        let availableColors = {};
        obj.sizes.forEach(function(sizeObj) {
          sizeObj.variants.forEach(function(variantObj) {
            let title = variantObj.title.replace('"','');
            if( variantObj.available ) availableColors[title] = 1;
          })
        });

        objects[handle].colorsCount = Object.keys(availableColors).length;
      }
    }

    if(!overwrite) {
      let existing = localStorage.getItem("allCollectionProducts");
      if(existing != null) objects = Object.assign(JSON.parse(existing), objects);
    }

    // Try to save to local storage.
    // If there are too many products/variants it will fail and the products
    // will be fetched via ajax again on the next page load.
    if(!isSafari) {
      try {
        localStorage.setItem("allCollectionProducts", JSON.stringify(objects));
        localStorage.setItem("allCollectionProductsTimestamp", Math.floor(Date.now() / 1000).toString());
        firstLoad = false;
      }
      catch (e) {
        console.error("Local Storage is full, Please empty data", e);
      }
    }
    return objects;
  }

  /**
   * Some child products have different handle bases (handle without the size part) than
   * their parent products and are missed/skipped in the default mapping.
   * This function links those child products to their proper parents.
   *
   * @param objects
   * @returns {*}
   */
  function parseMetafieldColorCount(objects) {
    let metafieldProducts = $('#bc-sf-filter-wrapper').attr('data-color_count_products');
    // WS: guard empty/blank/invalid metafield (was throwing 'Unexpected end of JSON input')
    if (!metafieldProducts || !metafieldProducts.trim()) { return objects; }
    try { metafieldProducts = JSON.parse(metafieldProducts); }
    catch (e) { return objects; }

    for (let parentHandle in metafieldProducts) {
      if(!metafieldProducts.hasOwnProperty(parentHandle)) continue;
      let children = metafieldProducts[parentHandle];

      for (let sizeHandle in children) {
        if(!children.hasOwnProperty(sizeHandle)) continue;
        let childHandle = children[sizeHandle];

        if(objects.hasOwnProperty(childHandle)) {
          if( typeof objects[parentHandle].sizes == "undefined" ) objects[parentHandle].sizes = [];
          objects[parentHandle].sizes.push(objects[childHandle]);
          delete objects[childHandle];
        }
      }
    }

    return objects;

  }
}